import Head from 'next/head';
import useLoadTracking from '../../../utils/tracking/useLoadTracking';

const Hotjar = () => {
  const { load } = useLoadTracking();
  if (!load) {
    return null;
  }
  return <HotjarWrapper />;
};

const HotjarWrapper = () => (
  <Head>
    <script
      dangerouslySetInnerHTML={{
        __html: `
    (function(h,o,t,j,a,r){
      h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
      h._hjSettings={hjid:2002976,hjsv:6};
      a=o.getElementsByTagName('head')[0];
      r=o.createElement('script');r.async=1;
      r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
      a.appendChild(r);
  })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
    `,
      }}
    />
  </Head>
);

export default Hotjar;
